module.exports = __webpack_public_path__ + "static/media/email-white.30596181.svg";